import React from 'react';
// Constants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  bathroomsPageAdditionalMeta,
  bathroomsPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import BathroomsPageMainContainer from '../../components/bathrooms/BathroomsPageMainContainer';
import GeneralHeader from '../../components/headers/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function BathroomsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Bathrooms'
        desc={`Get in touch with ${CompanyName} for expert bathroom installation and renovation services in ${LocationCity}. Whether you're planning a full remodel or need repairs, we’re here to help.`}
        keywords={`bathroom installation, bathroom renovation, plumbing, tiling, ${CompanyName}, bathrooms, quotes, inquiries, ${LocationCity}, UK`}
        additionalMeta={bathroomsPageAdditionalMeta}
        structuredData={bathroomsPageStructuredData}
      />
      <div className='grid min-h-screen overflow-hidden bg-colour3 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <GeneralHeader ServiceName='Bathrooms' bgImage={'bg-bathroom'} />

          {/* Main page content */}
          <BathroomsPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default BathroomsPage;
